module.exports = __webpack_public_path__ + "img/45_14.334a7cad.png";